import React, { Component } from 'react'
import '../Reportes/estilo.css'
import '../css/bulma.css'

export default class Empleado extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className="back">
            <div className="columns">
                <div className='color column is-4 is-offset-4'>
                    <figure className="is-4 color">
                        <img className="bordes" src={this.props.empleado.foto} width="100px" height="100px"/>
                    </figure>
                </div>
            </div>
            <div className=" scrolle columns">
                <div className="anchoD column is-8 is-offset-2">
                    <div className="columns">
                        <div className="fondo column is-12">   
                            <h2>Nombre: {this.props.empleado.nombre}</h2> 
                        </div>
                    </div>
                    <div className="columns">
                        <div className="fondo2 column is-12">
                            <h2>Socio: {this.props.empleado.nombresocio}</h2>     
                        </div>
                    </div>
                    <div className="columns">
                        <div className="fondo column is-12">   
                            <h2>Correo: {this.props.empleado.correo}</h2>  
                        </div>
                    </div>
                    <div className="columns">
                        <div className="fondo2 column is-12">
                            <h2>Placa: {this.props.empleado.placa}</h2>     
                        </div>
                    </div>
                    <div className="columns">
                        <div className="fondo column is-12">  
                            <h2>Tipo vehiculo: {this.props.empleado.tipoV}</h2>   
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/views/empledo.js